// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-template-component .btn-box[data-v-30a22ca0] {\n  text-align: right;\n}", ""]);
// Exports
module.exports = exports;
